import { TokenService } from '@/services';
import { refreshTokenFx, setAuthState } from '@/store';

export async function requestInterceptor(config = {} as any) {
  const controller = new AbortController();
  config.signal = controller.signal;

  const tokenInfo = TokenService.get();

  if (tokenInfo) {
    let token = tokenInfo.token;
    const { isExpired, isRefreshing, authType } = tokenInfo;

    if (isExpired) {
      if (isRefreshing) {
        config.canceledTokenExpired = true;

        controller.abort();
      } else {
        try {
          const refreshedTokenInfo = await refreshTokenFx({ token, authType });

          refreshedTokenInfo?.token
            ? (token = refreshedTokenInfo.token)
            : setAuthState({ authorized: false, authChecked: true });
        } catch (e) {
          setAuthState({ authorized: false, authChecked: true });
          TokenService.set({ ...tokenInfo, isRefreshing: false });
        }
      }
    }

    config = { ...config, headers: { ...config.headers, Authorization: `Bearer ${token ?? ''}` } };
  }

  return config;
}

async function reFetch(originalFetch: any) {
  const DELAY = 400;

  const delayRetryRequest = new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, DELAY);
  });

  return delayRetryRequest.then(() => originalFetch());
}

export async function responseInterceptor(config: any, originalFetch: any, error: any) {
  if (config.canceledTokenExpired) {
    return await reFetch(originalFetch);
  }

  return Promise.reject(error);
}

export const fetchWithHeaders = async (url: RequestInfo | URL, config = {}): Promise<Response> => {
  const customConfig = await requestInterceptor(config);

  if (customConfig.canceledTokenExpired) {
    customConfig.canceledTokenExpired = false;

    return await reFetch(() => fetchWithHeaders(url, customConfig));
  } else {
    const response = await fetch(url, customConfig);

    if (!response.ok && response.status === 404) {
      return Promise.reject(response);
    }

    return response;
  }
};
